<script>
    import CRUD from './CRUD.svelte';
    import { t } from 'svelte-i18n';
    import { fetchEscoltas, saveEscolta, removeEscolta, searchEscoltas, subscribeToEscoltas, unsubscribeFromEscoltas } from '../controllers/escoltaController.js';

    // Configuración de las columnas para la tabla de escoltas
    let escoltaColumns = [
      { label: 'Nombre', field: 'nombre', type: 'text' },
      { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    // Estructura del nuevo objeto Escolta
    let newEscolta = {
      id: '',
      nombre: '',
      sta: true,
    };

    // Configuración de los campos para la edición de escoltas
    let editColumns = [
        { label: 'Nombre', key: 'nombre', type: 'text', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox', required: true }
    ];
</script>

<CRUD 
    title={$t('entities.escoltas')}
    entityName="escolta"
    newEntity={newEscolta}
    columns={escoltaColumns}
    fetchEntities={fetchEscoltas}
    saveEntity={saveEscolta}
    removeEntity={removeEscolta}
    searchEntities={searchEscoltas}
    subscribeToChanges={subscribeToEscoltas}
    unsubscribeFromChanges={unsubscribeFromEscoltas}
    editColumns={editColumns}
/>